import * as Sentry from "@sentry/browser";
import { AngularFireModule } from "@angular/fire";
import { AngularFirestoreModule } from "@angular/fire/firestore";
import { AngularFireAnalyticsModule } from "@angular/fire/analytics";
import { ApiInterceptor } from "../interceptors/token-interceptor";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { AuthEffects, UserEffects } from "@store/user";
import { BasePageModule } from "./base/base.module";
import { BrowserModule } from "@angular/platform-browser";
import {
  CarryBagService,
  OrderHistoryService,
  OutOfStockProductsService,
  PlaceOrderService,
  InstantSyncOrderService,
  QuoteSerializerService,
  StorageService,
  StoreAddressService,
  StoreDetailService,
  ValidateCouponService,
  CreateQuoteService,
  TrackingService,
  CustomerAddressService,
} from "@tendercuts/providers";
import { CartEffects } from "@store/cart";
import { CatalogEffects } from "@store/catalog";
import { StoreEffects } from "@store/store-state";
import {
  ConnectionService,
  ConnectionServiceModule,
} from "ng-connection-service";
import {
  Constants,
  devTools,
  firebaseConfig,
  SentryErrorHandler,
} from "@app/env";
import { EffectsModule } from "@ngrx/effects";
import { ErrorHandler, Injectable, NgModule } from "@angular/core";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { IonicStorageModule } from "@ionic/storage";
import { reducerToken } from "@store/reducers";
import { RouteReuseStrategy } from "@angular/router";
import { SharedModule } from "./shared.module";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { StoreModule } from "@ngrx/store";

Sentry.init({
  dsn: "https://553ab99980474a54897bd39a614af0b5@sentry.io/1783573",
});

export function environmentFactory() {
  return new Constants();
}

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BasePageModule,
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    ConnectionServiceModule,
    SharedModule,
    IonicStorageModule.forRoot(),
    // Uncommand below line while migrating to angular 4
    StoreModule.forRoot(reducerToken),
    EffectsModule.forRoot([
      CatalogEffects,
      StoreEffects,
      CartEffects,
      AuthEffects,
      UserEffects,
    ]),
    StoreModule.forFeature("appState", reducerToken),
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFirestoreModule,
    AngularFireAnalyticsModule,
    devTools,
  ],
  providers: [
    ConnectionService,
    StatusBar,
    SplashScreen,
    StorageService,
    StoreAddressService,
    StoreDetailService,
    PlaceOrderService,
    InstantSyncOrderService,
    OutOfStockProductsService,
    QuoteSerializerService,
    ValidateCouponService,
    CreateQuoteService,
    CarryBagService,
    TrackingService,
    CustomerAddressService,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: Constants, useFactory: environmentFactory },
    { provide: ErrorHandler, useClass: SentryErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
